import Pristine from 'pristinejs';
import { console, document } from 'window-or-global';
import { fetchContentDataBySlotId, getDataBySlotId, getPropertyName, textFieldCharCount } from '../repairsForm/amplienceDCUtilities';

const setStores = (shopAddresses) => {
  const url = window.location.href;
  let country;

  if (url.match(/\/gb/) || url.match(/\-\-gb/)) {
    country = 'United Kingdom';
  }
  if (url.match(/\/ie/) || url.match(/\-\-ie/)) {
    country = 'Ireland';
  }
  if (url.match(/\/us/) || url.match(/\-\-us/)) {
    country = 'United States';
  }
  if (url.match(/\/nl/) || url.match(/\-\-nl/)) {
    country = 'Netherlands';
  }
  if (url.match(/\/fr/) || url.match(/\-\-fr/)) {
    country = 'France';
  }
  if (url.match(/\/dk/) || url.match(/\-\-dk/)) {
    country = 'Denmark';
  }
  if (url.match(/\/se/) || url.match(/\-\-se/)) {
    country = 'Sweden';
  }
  if (url.match(/\/de/) || url.match(/\-\-de/)) {
    country = 'Germany';
  }
  if (url.match(/\/ch/) || url.match(/\-\-ch/)) {
    country = 'Switzerland';
  }
  if (url.match(/\/au/) || url.match(/\-\-au/)) {
    country = 'Australia';
  }
  if (url.match(/\/nz/) || url.match(/\-\-nz/)) {
    country = 'New Zealand';
  }

  const storeSelect = document.getElementById(getPropertyName('prefferedStore'));

  shopAddresses.forEach((address, i) => {
    if (address.country == country) {
      const option = `<option value="${address.storeName}">${address.storeName}</option>`;

      storeSelect.innerHTML = storeSelect.innerHTML + option;
    }
  });
};

export const initAppointmentForm = () => {
  const submitButton = document.getElementById('appointmentSubmitBtn');
  const apptForm = document.getElementById('appointmentForm');
  let pristine = new Pristine(apptForm, {}, false);
  const apptForSel = document.getElementById(getPropertyName('appointmentType'));
  const textAreaWithCount = document.getElementById(getPropertyName('reason'));

  let shopAddresses;

  const loadStoreData = () =>
    new Promise((resolve, reject) => {
      return resolve();
    });

  loadStoreData()
    .then(() => fetchContentDataBySlotId('b82f6d90-202c-43c7-89c2-682ee774432b'))
    .then(() => {
      const data = getDataBySlotId('b82f6d90-202c-43c7-89c2-682ee774432b');

      shopAddresses = data.shopAddresses;

      setStores(shopAddresses);
    });

  apptForSel.addEventListener('change', (e) => {
    const guestInfo = document.getElementById('appointment-form-guest-info');
    const inputs = document.querySelectorAll('#appointment-form-guest-info input');
    if (e.target.value == 'No') {
      guestInfo.classList.remove('hidden');

      for (let i = 0; i < inputs.length; i++) {
        inputs[i].required = true;
      }

      document.getElementById(getPropertyName('appointmentTitle')).required = true;
    } else {
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].required = false;
      }
      document.getElementById(getPropertyName('appointmentTitle')).required = false;
      guestInfo.classList.add('hidden');
    }

    pristine.reset();
    pristine.destroy();
    pristine = new Pristine(apptForm, {}, false);
  });

  textAreaWithCount.addEventListener('keyup', (e) => {
    textFieldCharCount(e.target);
  });

  apptForm.addEventListener('submit', (e) => {
    e.preventDefault();
    if (pristine.validate()) {
      apptForm.submit();

      return true;
    } else {
      return false;
    }
  });
};

export default () => {
  let appointmentForm = !!document.getElementById('appointmentForm');

  if (appointmentForm) {
    initAppointmentForm();
  }
};
